// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ExampleContainer = {
    list: (value) => {
        return Object.assign(Object.assign({}, value), { type: "list", _visit: function (visitor) {
                return FernIr.ExampleContainer._visit(this, visitor);
            } });
    },
    set: (value) => {
        return Object.assign(Object.assign({}, value), { type: "set", _visit: function (visitor) {
                return FernIr.ExampleContainer._visit(this, visitor);
            } });
    },
    optional: (value) => {
        return Object.assign(Object.assign({}, value), { type: "optional", _visit: function (visitor) {
                return FernIr.ExampleContainer._visit(this, visitor);
            } });
    },
    nullable: (value) => {
        return Object.assign(Object.assign({}, value), { type: "nullable", _visit: function (visitor) {
                return FernIr.ExampleContainer._visit(this, visitor);
            } });
    },
    map: (value) => {
        return Object.assign(Object.assign({}, value), { type: "map", _visit: function (visitor) {
                return FernIr.ExampleContainer._visit(this, visitor);
            } });
    },
    literal: (value) => {
        return Object.assign(Object.assign({}, value), { type: "literal", _visit: function (visitor) {
                return FernIr.ExampleContainer._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "list":
                return visitor.list(value);
            case "set":
                return visitor.set(value);
            case "optional":
                return visitor.optional(value);
            case "nullable":
                return visitor.nullable(value);
            case "map":
                return visitor.map(value);
            case "literal":
                return visitor.literal(value);
            default:
                return visitor._other(value);
        }
    },
};
